import React from "react";

export const Footer = (): JSX.Element => {
    return (
        <div className="w-auto px-5 py-10 flex justify-evenly items-center bg-gradient-to-r from-cyan-600 to-blue-600">
            <span className="flex text-white">
                <span>By <span className="font-bold">{"</lspecht>"}</span> </span>
            </span>
        </div>
    )
}